// extracted by mini-css-extract-plugin
module.exports = {"title":"about-module__title___YGr28","divider":"about-module__divider___brvSj","section":"about-module__section___i6DxU","subtitle":"about-module__subtitle___FGjfd"};